<template>
    <div>
        <public-head title="校派"></public-head>

        <div class="wrap" id="content">
            <div class="title">
                {{title}}
            </div>
            <div class="content">
                <p v-html="content" class="fuwen"></p>
            </div>
        </div>
    </div>
</template>

<script>
import { httpPost, httpGet } from "../../../../axios/index";
import publicHead from "../../../../components/publicHead";
export default {
    data(){
        return{
            title:'',
            content:""
        }
    },
    methods: {
        // 获取详情数据
        fetchDetailData(){
             httpPost("/optimi/view", {
               id:this.$route.query.id
            }).then(res => {
              
                if (res.code === 1) {
                    this.title=res.data.title
                    this.content=res.data.content;
                }
            });
        }
    },
     mounted(){
         this.fetchDetailData();
     },
     components:{
         publicHead
     }
};
</script>

<style scoped>
.fuwen >>> img,p,span {
    width: 100%;
}
.wrap{
    margin-top: 46px;
}
    .title{
        font-size: 20px;
        font-weight: bold;
    }
    .content{
        font-size: 18px;
    }
</style>